module.exports = __webpack_public_path__ + "static/media/ftu-exercises.e53e79a6.png";